import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApmcSchemes, applyNewApmcApplication } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { languageMapping } from './GujaratScheme';
import { toast, ToastContainer } from 'react-toastify';

interface Scheme {
  name: string;
  description: string;
  amount: string;
  duration: string;
  purposes: string[];
}
interface SchemeItem  {
  id: number;
  scheme: string;
  subName: string;
};

const SchemeSelector = () => {
  const token = useSelector((state:any)=>state.auth.token);
  const [schemes, setSchemes] = useState<Scheme[]>([]);
  const [selectedScheme, setSelectedScheme] = useState<Scheme | null>(null);
  
  // const [appid,setAppId]=useState<string>();
  const navigate = useNavigate();

  const handleProceed = async() => {
    if( !selectedScheme){
            toast.warning(
           "Select Scheme",
              {
                position: "top-right",
                style: { fontSize: "1.2rem", padding: "16px" },
              }
            );
            return;
    }
    navigate('/apmc',{
        state:{scheme:selectedScheme,
          // schemeID:

          
          // applicationId: res?.data?.applicationId,
          // couchId: res?.data?.applicationCouchId,
        }
      });
  
  };

  const fetchAllSchemes = async () => {
    const response = await getApmcSchemes();
    
    const rawSchemes = response?.data || [];
    const formattedSchemes = rawSchemes.map((item: any) => ({
      name: item.name,
      description: '',
      amount: '',
      duration: '',
      purposes: []
    }));
    setSchemes(formattedSchemes);
  };

  useEffect(() => {
    fetchAllSchemes();
  }, []);

  
const getGujaratiLabel = (english: string): string => {
 
  const match = languageMapping.find(item => item.value === english);
 
  return match?.label || '';
};

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center bg-light pt-4">
    <div className="container-fluid page-wrapper w-75 ">
      <div className="d-flex row g-4">
        <div className="col-md-8">
          <h4 className='text-success'>Step 1: Select a Scheme</h4>
          <p className="text-muted">Choose the scheme that best fits your requirements</p>
          <div className="row g-3">
            {schemes.map((scheme) => (
              <div className="col-md-6" key={scheme.name}>
                <div
                  className={`card h-100 p-2 ${
                    selectedScheme?.name === scheme.name ? 'border-info bg-info text-white' : ''
                  }`}
                  onClick={() => {
                    setSelectedScheme(scheme);
              
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <div className='d-flex flex-column justify-content-evenly h-100'>
                  <h6 className={` ${selectedScheme?.name === scheme.name ? 'text-white' : ''}`}>
                    {getGujaratiLabel(scheme.name)}
                    <br />
                  </h6>
                    <small className={selectedScheme?.name === scheme.name ? 'text-white-50'  : 'text-muted'}>
                      {scheme.name}
                    </small>
                    {/* <small className={`d-block mb-2 ${selectedScheme?.name === scheme.name ? 'text-white-50' : 'text-muted'}`}>
                      {scheme.description}
                    </small>
                    <div className="d-flex gap-2">
                      <span className={`badge ${selectedScheme?.name === scheme.name ? 'bg-light text-dark' : 'bg-secondary-subtle text-dark'}`}>
                        {scheme.amount}
                      </span>
                      <span className={`badge ${selectedScheme?.name === scheme.name ? 'bg-light text-dark' : 'bg-secondary-subtle text-dark'}`}>
                        {scheme.duration}
                      </span> */}
                    </div>
                  </div>
                </div>
              
            ))}
          </div>
        </div>

        <div className="col-md-4">
          <h4 className='text-success'>Guidelines</h4>
          <p className="text-muted">Guidelines to follow:</p>

          {/* {selectedScheme && (
            <div className="bg-white p-3 rounded border mb-3" style={{height:"85px"}}>
              <div className="fw-bold">{selectedScheme.name}</div>
            </div>
          )} */}

          {/* {purposes.length > 0 ? (
            <div
              className="d-flex flex-column gap-2 bg-white border rounded p-2"
              style={{ height: '375px', overflowY: 'auto' }}
            >
              {purposes.map((purpose, index) => (
                <div key={purpose.id} className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="purpose"
                    id={`purpose-${index}`}
                    checked={selectedPurpose?.subName === purpose?.subName}
                    onChange={() => setSelectedPurpose(purpose)}
                  />
                  <label className="form-check-label" htmlFor={`purpose-${index}`}>
                    {getGujaratiLabel(purpose.subName)}
                    <br />
                    <small className="text-muted">{purpose?.subName}</small>
                  </label>

                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted small fst-italic">
              No purposes listed for this scheme.
              Please Select the Scheme First.
            </p>
          )} */}

          <button 
            className="btn btn-info w-100 mt-4"
            onClick={handleProceed}
            >
            Proceed to Application Form →</button>
        </div>
      </div>
    </div>
    <ToastContainer position='top-left' autoClose={3000}/>
    </div>
  );
};

export default SchemeSelector;


